
import {PreferencesService} from "@irb-common/services/preferences.service";
import {Directive, HostListener} from "@angular/core";


@Directive()
export class IrbGridBaseClass {
    gridFilterPreference: string;
    isUiTest: boolean;
    baseGridApi: any;
    pref: PreferencesService;
    initialLoadTriggered: boolean = false;
    private useApplyFilterOnLanding = false;
    gridColumnPreference: string;
    componentName: string;
    hasServerSideDatasource: boolean;
    saveStateColumnEnabledAfterLoading: boolean = false;


    setDatasource() {}

    saveGridFiltersToLocal(filterChipModel: any) {
        if (filterChipModel) {
            let filterModel = JSON.parse(JSON.stringify(filterChipModel));
            delete filterModel.quickfilter;
            if (this.useApplyFilterOnLanding)
                this.initialLoadTriggered = false;
            if (JSON.stringify(filterModel) === '{}') {
                this.pref.setGridFilterPreference(this.gridFilterPreference, null, this.initialLoadTriggered);
                this.initialLoadTriggered = false;
                return;
            }
            this.pref.setGridFilterPreference(this.gridFilterPreference, filterModel, this.initialLoadTriggered);
            for (const key in filterModel) {
                if (filterModel.hasOwnProperty(key) && key !== 'quickfilter') {
                    // quick-filter; guard against null
                    const column = this.baseGridApi.getColumn(key);
                    if (column) {
                        column.filterActive = true;
                    }
                }
            }
        } else
            this.useApplyFilterOnLanding = true;
        this.initialLoadTriggered = false;
    }

    triggerInitialLoadData(timeoutFilter: number = 0) {
        this.initialLoadTriggered = true;
        let savedFilters = this.getGridFilterPreference();

        if (!savedFilters || JSON.stringify(savedFilters) === '{}') {
            this.baseGridApi.setGridOption('serverSideDatasource', this.setDatasource());
            if (!this.isUiTest)
                setTimeout(() => { this.saveStateColumnEnabledAfterLoading = true; }, 2000);
        } else {
            setTimeout(() => {
                //savedFilters = JSON.parse(savedFilters);
                for (const [key, value] of Object.entries(savedFilters)) {
                    this.baseGridApi.setColumnFilterModel(key, value).then(() => {
                        this.baseGridApi.onFilterChanged();
                    });
                }
                const timeoutDS: number = this.isUiTest ? 0 : 100;
                setTimeout(() => {
                    this.useApplyFilterOnLanding = false;
                    this.baseGridApi.setGridOption('serverSideDatasource', this.setDatasource());
                    this.baseGridApi.refreshHeader();
                    if (!this.isUiTest)
                        setTimeout(() => { this.saveStateColumnEnabledAfterLoading = true; }, 2000);
                }, timeoutDS);
            }, timeoutFilter);
        }
    }

    getGridFilterPreference() {
        const gridPreferences = !this.useApplyFilterOnLanding ? this.pref.getGridFilterPreference(this.gridFilterPreference) : null;
        return gridPreferences;
    }

    @HostListener("window:beforeunload", ["$event"])
    onBeforeUnload(event: any) {
        if (!this.isUiTest) {
            delete event.returnValue;
            this.pref.saveIrebalPreferences();
        }
    }

    getGridColumnPreference() {
        const columnPreferences: any = this.pref.getGridFilterPreference(this.gridColumnPreference) || null;
        if (columnPreferences)
            localStorage.setItem(this.componentName, JSON.stringify(columnPreferences));
    }

    saveGridColumnPreference(stateValue: any) {
        if (this.saveStateColumnEnabledAfterLoading) {
            const currentState: string = this.pref.getGridFilterPreference(this.gridColumnPreference);
            if (stateValue !== currentState) {
                this.pref.setGridFilterPreference(this.gridColumnPreference, stateValue, false);
            }
        }
    }

}
